import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { SidebarItem, SidebarSection } from '@app/app/shared/models/sidebar/sidebar.model';
import { ArrowDown01Icon, ArrowLeft01Icon } from '@hugeicons/core-free-icons/index';

@Component({
  selector: 'ptl-sidebar-sections',
  templateUrl: './sidebar-sections.component.html',
  styleUrls: ['./sidebar-sections.component.scss'],
})
export class SidebarSectionsComponent {
  @Input() sections: SidebarSection[] = [];

  @Output() itemClick = new EventEmitter<{ item: SidebarItem; event: Event }>();

  protected readonly ArrowLeft01Icon = ArrowLeft01Icon;
  protected readonly ArrowDown01Icon = ArrowDown01Icon;

  constructor(private router: Router) {}

  onItemClick(event: Event, item: SidebarItem): void {
    if (item.isBackButton && item.url) {
      event.preventDefault();
      event.stopPropagation();
      this.router.navigateByUrl(item.url);
      return;
    }

    this.itemClick.emit({ item, event });
  }

  toggleExpand(item: SidebarItem): void {
    item.expanded = !item.expanded;
  }
}
